import styled from 'styled-components';

export const StyledLogoFileUpload = styled.div`
   max-width: 505px;
`;
StyledLogoFileUpload.displayName = 'StyledLogoFileUpload';
